import { createContext, useContext, useState } from 'react'
import { useApi } from 'hooks/useApi'

import { useAuthStore } from 'stores/authStore'
import { useWebSocket } from 'hooks/useWebSocket'
import { hostname } from 'helpers/hostname'

const WebSocketContext = createContext(null)

export const WebSocketProvider = ({ children }) => {
  const { setAuth, deleteAuth, auth, isAuth } = useAuthStore()
  const { request } = useApi()
  const [lastMessage, setLastMessage] = useState(null)

  const handleSubmit = async (username, password) => {
    const formData = new FormData()
    formData.append('username', username)
    formData.append('password', password)

    const { error} = await request('POST', 'login/', formData)
    if (!error) {
      window.location.href = '/'
    }
  }

  const {socketRef, sendWhenReady} = useWebSocket({
    url: hostname('WSS_PROD'),
    onOpen: (socket) => {
      if (isAuth()) {
        socket.send(JSON.stringify({ cmd: 'login', token: auth?.token }))
      }
    },
    onMessage: (message, socket) => {
      setLastMessage(message)
      const { cmd, data, topic } = message

      if (message.cmd === 'ping') {
        socket.send(JSON.stringify({ cmd: 'pong' }))
      }

      if (cmd === 'logout') {
        deleteAuth()
      }

      if (cmd === 'autologin') {
        handleSubmit(data.login, data.password)
      }

      if (cmd === 'set-credits' && topic === 'account') {
        setAuth({ ...auth, credits: data })
      }
    }
  })

  return (
    <WebSocketContext.Provider value={{ socketRef, sendWhenReady, lastMessage }}>
      {children}
    </WebSocketContext.Provider>
  )
}

export const useWebSocketContext = () => useContext(WebSocketContext)
